import React from "react";

const AddPlayerIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5832 11.9642C15.8761 11.9642 16.9242 10.7664 16.9242 9.28874C16.9242 7.81113 15.8761 6.61328 14.5832 6.61328C13.2903 6.61328 12.2422 7.81113 12.2422 9.28874C12.2422 10.7664 13.2903 11.9642 14.5832 11.9642Z"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M11.0063 19.1318H10.0176V16.0637C10.0176 14.3334 11.4135 12.9375 13.1438 12.9375"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M15.7321 12.9375C17.4624 12.9375 18.8583 14.3334 18.8583 16.0637V19.1318H12.6641"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M24.4998 13.4596C24.4998 18.9414 20.065 23.3763 14.5832 23.3763C9.10138 23.3763 4.6665 18.9414 4.6665 13.4596C4.6665 7.97784 9.10138 3.54297 14.5832 3.54297"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M21.3882 3.5V9.72336"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M24.4998 6.61328H18.291"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default AddPlayerIcon;
